import React from "react";
import {
  Container,
  TextField,
  Button,
  Alert,
  Box,
  Chip,
  InputAdornment,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SearchIcon from "@mui/icons-material/Search";

function CmsSearchForm({
  searchTerm,
  setSearchTerm,
  handleSearch,
  error,
  loading,
  aiModel,
}) {
  // Trigger search on Enter without form submit.
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  return (
    <Container
        maxWidth={false}
        sx={{
            py: 2,
            px: { xs: 2, md: 4 }, // kontrollierter Abstand links
        }}
>
      
      {/* Model chip */}
      <Box sx={{ mb: 1.5 }}>
        <Chip
          icon={<AutoAwesomeIcon />}
          label={aiModel}
          size="small"
          sx={{
            fontFamily: "monospace",
            fontWeight: 600,
            color: "white",
            border: "none",
            background: "linear-gradient(90deg,#1a73e8,#9334e6)",
            "& .MuiChip-icon": { color: "white" },
          }}
        />
      </Box>

      {/* Search row */}
      <Box
        sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            flexDirection: { xs: "column", sm: "row" },
            maxWidth: 600,   // <- maximale Breite
        }}
>
        <TextField
          placeholder="Firma, Branche, Ort …"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              height: 42,
              borderRadius: 2,
            },
            "& .MuiOutlinedInput-input": {
              py: 0,
            },
          }}
        />

        <Button
          variant="contained"
          onClick={handleSearch}
          disabled={loading || !searchTerm.trim()}
          startIcon={<SearchIcon />}
          sx={{
            height: 42,
            borderRadius: 2,
            px: 3,
            textTransform: "none",
            fontWeight: 600,
            boxShadow: "none",
            alignSelf: { xs: "stretch", sm: "auto" },
          }}
        >
          {loading ? "Suche läuft…" : "Suchen"}
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Container>
  );
}

export default CmsSearchForm;